module.exports = __webpack_public_path__ + "img/caracteristicas-intervensionista.5bb66d50.png";